import { Controller } from "@hotwired/stimulus"

// Shows the instance URL field only when the client says their org is on an alternative host.
//
// `required` is applied and removed alongside visibility on purpose: a hidden required input
// blocks submission with a browser message pointing at an element nobody can see, which reads as
// the button being broken.
export default class extends Controller {
  static targets = ["toggle", "field", "input"]

  connect() {
    this.sync()
  }

  sync() {
    const enabled = this.toggleTarget.checked

    this.fieldTarget.hidden = !enabled
    this.inputTarget.required = enabled

    if (!enabled) {
      this.inputTarget.value = ""
    }
  }

  // Hosts are case-insensitive and the server downcases before checking, but a pattern attribute
  // takes no case-insensitivity flag — so an uppercase letter would be refused by the browser for
  // a host the server would accept. Lowercased on blur rather than on every keystroke: it only
  // has to be settled before the browser validates, which is on submit.
  //
  // The action has to stay on the input itself. blur does not bubble, so moving it to a wrapper
  // would silently stop firing; focusout is the bubbling equivalent if it ever needs to move.
  normalize() {
    this.inputTarget.value = this.inputTarget.value.toLowerCase()
  }
}
